import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { bumexFeatureOperations } from '../state/ducks/bumexFeatures';
import { bumexFeaturesKeys } from '../constants/bumexFeatures';

const useBumexFeatures = () => {
  const dispatch = useDispatch();
  const allBumexFeaturesKeys = Object.keys(bumexFeaturesKeys);

  useEffect(() => {
    dispatch(bumexFeatureOperations.getBumexFeatureBulk(allBumexFeaturesKeys));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export { useBumexFeatures };
